import React from 'react';
import { ThemeConsumer } from 'styled-components';
import IconBuildingAppartment from '../../../../assets/images/IconBuildingAppartment';
import IconBuildingClosed from '../../../../assets/images/IconBuildingClosed';
import IconBuildingHalfOpen from '../../../../assets/images/IconBuildingHalfOpen';
import {
  IconTenantFilled,
  IconLandlordFilled,
  IconLiabilitybuildingFilled,
  IconPersonalLiabilityFilled,
  IconHomeOfficeFilled,
  IconConsumerFilled,
  IconPropertyFilled,
} from 'wg-fe-ui';

interface Props {
  type?: string;
}

const IconSelector: React.FC<React.PropsWithChildren<Props>> = ({ type }) => {
  return (
    <ThemeConsumer>
      {(theme) => {
        switch (type?.toLowerCase()) {
          case 'natural':
            return <IconConsumerFilled color={theme.primary[500]} />;
          case 'legal':
            return <IconHomeOfficeFilled color={theme.primary[500]} />;
          case 'apartment':
            return <IconBuildingAppartment theme={theme} />;
          case 'halfopen':
            return <IconBuildingHalfOpen theme={theme} />;
          case 'closed':
            return <IconBuildingClosed theme={theme} />;
          case 'open':
            return <IconPropertyFilled theme={theme} />;
          case 'owner':
            return <IconTenantFilled color={theme.primary[500]} />;
          case 'tenant':
            return <IconLandlordFilled color={theme.primary[500]} />;
          case 'landlord':
            return <IconLiabilitybuildingFilled color={theme.primary[500]} />;
          case 'co_tenant':
            return <IconPersonalLiabilityFilled color={theme.primary[500]} />;
          default:
            return 'No icon';
        }
      }}
    </ThemeConsumer>
  );
};

export default IconSelector;
